(() => {
  if (window.sniffcarWizardInstalled) return;
  window.sniffcarWizardInstalled = true;

  const steps = [
    ['Menge', 'Menge auswählen', 'Ein Klick auf das passende Paket führt direkt zum Design.'],
    ['Design', 'Design hochladen', 'Logo oder Grafik hochladen, bei Bedarf die Rückseite ergänzen und die Wunschform wählen.'],
    ['Duft', 'Duft auswählen', 'Den passenden Duft und die gewünschte Intensität für das gewählte Paket festlegen.'],
    ['Angaben', 'Wünsche ergänzen', 'Designwünsche und eine Handynummer für die Abstimmung des Entwurfs ergänzen.'],
    ['Prüfen', 'Auswahl prüfen', 'Alle Angaben kontrollieren. Über „Ändern“ lässt sich jeder Schritt noch einmal bearbeiten.'],
  ];
  const nextLabels = ['Zum Design →', 'Duft auswählen →', 'Wünsche ergänzen →', 'Auswahl prüfen →'];
  const fieldSteps = {
    'file-1': 1, 'file-2': 1, 'heading-4': 1, 'image-dropdown-1': 1, 'textarea-2': 1,
    'image-dropdown-2': 2, 'image-dropdown-6': 2, 'image-dropdown-9': 2,
    'image-dropdown-7': 2, 'image-dropdown-8': 2, 'image-dropdown-10': 2,
    'image-dropdown-11': 2, 'image-dropdown-12': 2, 'image-dropdown-13': 2,
    'image-dropdown-14': 2, 'select-1': 2, 'heading-3': 2, 'heading-2': 2,
    'textarea-1': 3, 'phone-1': 3,
  };
  const cls = (node, name, on) => {
    if (node && node.classList.contains(name) !== on) node.classList.toggle(name, on);
  };
  const concealed = (node, on) => cls(node, 'sc-wizard-hidden', on);

  class SniffcarWizard {
    constructor(root) {
      this.root = root;
      this.step = 0;
      this.visited = 0;
      this.pendingValue = null;
      this.ready = false;
      this.observer = new MutationObserver((records) => {
        if (records.every(r => r.target.closest?.('[data-sc-generated]'))) return;
        this.scheduleRefresh();
      });
      this.observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      root.addEventListener('click', event => this.onClick(event));
      root.addEventListener('input', () => { if (this.step === 4) this.renderSummary(); });
      root.addEventListener('change', () => this.scheduleRefresh());
      document.addEventListener('gpoRenderCompleted', () => this.scheduleRefresh());
      document.addEventListener('gpoElementChanged', () => this.scheduleRefresh());
      document.addEventListener('gpoValidated', event => {
        if (this.submitting && event.detail?.success === false) this.revealError();
      });
      root.addEventListener('click', event => {
        if (event.target.closest('[id^="ProductSubmitButton-"]')) {
          this.submitting = true;
          setTimeout(() => { this.revealError(); this.submitting = false; }, 0);
        }
      }, true);
      this.refresh();
    }

    scheduleRefresh() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
    }

    refresh() {
      if (!this.root.isConnected) { this.observer.disconnect(); this.surfaceObserver?.disconnect(); return; }
      this.picker = this.root.querySelector('variant-selects:not([style*="display: none"])');
      this.app = this.root.querySelector('.gpo-app[data-option-set-id="1155084"]');
      if (!this.picker?.querySelector('[data-sniffcar-packages]') || !this.app?.querySelector('#phone-1')) return;
      if (!this.ready) this.initialize();
      if (!this.ready) return;
      this.app.querySelectorAll('.gpo-element[data-element-id]').forEach(field => {
        const step = fieldSteps[field.dataset.elementId];
        // Unknown future input fields remain reachable in Details; decorative rows are omitted.
        const assigned = step ?? (field.querySelector('input,select,textarea') ? 3 : -1);
        field.dataset.scFieldStep = String(assigned);
        concealed(field, assigned !== this.step);
      });
      this.applyPanels();
      if (this.pendingValue) this.finishPackageSelection();
      if (this.step === 4) this.renderSummary();
      this.updateSurface();
    }

    initialize() {
      this.info = this.root.querySelector('[id^="ProductInfo-"]');
      this.appBlock = this.app.closest('.shopify-app-block');
      this.price = this.root.querySelector('[id^="price-template"]');
      this.tax = this.root.querySelector('.product__tax');
      this.productForm = this.root.querySelector('product-form');
      this.purchase = this.productForm?.parentElement;
      if (!this.info || !this.appBlock || !this.price || !this.purchase || this.purchase.parentElement !== this.info) return;

      this.header = document.createElement('div');
      this.header.className = 'sc-wizard__header';
      this.header.dataset.scGenerated = '';
      this.header.innerHTML = '<h2 class="sc-wizard__intro-title">Ihr individueller Duftbaum <span>in 5 Schritten</span></h2>' +
        '<nav class="sc-wizard__progress" aria-label="Konfigurationsschritte"></nav>' +
        '<p class="sc-wizard__counter" aria-live="polite"></p>' +
        '<h3 class="sc-wizard__title" tabindex="-1"></h3><p class="sc-wizard__description"></p>' +
        '<button type="button" class="sc-wizard__package" data-sc-go="0"></button>';
      this.progress = this.header.querySelector('nav');
      steps.forEach(([label], index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.dataset.scGo = index;
        button.textContent = label; button.setAttribute('aria-label', `Schritt ${index + 1}: ${label}`);
        this.progress.append(button);
      });
      this.info.insertBefore(this.header, this.picker);

      this.summary = document.createElement('div');
      this.summary.className = 'sc-wizard__summary';
      this.summary.dataset.scGenerated = '';
      this.header.after(this.summary);

      this.navigation = document.createElement('div');
      this.navigation.className = 'sc-wizard__navigation';
      this.navigation.dataset.scGenerated = '';
      this.navigation.innerHTML = '<p class="sc-wizard__notice" role="status" hidden></p>' +
        '<div class="sc-wizard__actions"><button type="button" class="sc-wizard__back" data-sc-back>← Zurück</button>' +
        '<button type="button" class="sc-wizard__next" data-sc-next>Weiter →</button></div>';
      this.info.insertBefore(this.navigation, this.purchase);

      cls(this.appBlock, 'sc-wizard__options', true);
      cls(this.price, 'sc-wizard__price', true);
      cls(this.tax, 'sc-wizard__tax', true);
      cls(this.purchase, 'sc-wizard__purchase', true);
      // Retain every native node and listener in its original parent. Only visibility changes.
      let sibling = this.picker.nextElementSibling;
      while (sibling && sibling !== this.purchase) {
        if (![this.price, this.tax, this.appBlock, this.navigation].includes(sibling)) {
          cls(sibling, 'sc-wizard__interstitial', true);
        }
        sibling = sibling.nextElementSibling;
      }
      this.ready = true;
      this.info.dataset.scWizardReady = 'true';
      // One decorative surface spans the original sibling panels. Native fields
      // stay in their original parents, preserving Globo and Dawn listeners.
      this.surface = document.createElement('div');
      this.surface.className = 'sc-wizard__surface';
      this.surface.dataset.scGenerated = '';
      this.surface.setAttribute('aria-hidden', 'true');
      this.info.insertBefore(this.surface, this.header);
      this.surfaceObserver = new ResizeObserver(() => this.updateSurface());
      [this.info, this.header, this.navigation, this.purchase].forEach(node => this.surfaceObserver.observe(node));
      this.updateHeading();
    }

    updateSurface() {
      if (!this.surface || !this.header.offsetWidth) return;
      const bottom = this.purchase;
      const dimensions = {
        top: this.header.offsetTop,
        left: this.header.offsetLeft,
        width: this.header.offsetWidth,
        height: bottom.offsetTop + bottom.offsetHeight - this.header.offsetTop,
      };
      Object.entries(dimensions).forEach(([property, value]) => {
        const size = `${value}px`;
        if (this.surface.style[property] !== size) this.surface.style[property] = size;
      });
    }

    onClick(event) {
      if (!this.ready) return;
      const go = event.target.closest('[data-sc-go]');
      if (go && Number(go.dataset.scGo) <= this.visited) {
        const destination = Number(go.dataset.scGo);
        if (destination > this.step) {
          if (this.step === 0) { this.choosePackage(); return; }
          if (!this.validateStep()) return;
        }
        this.go(destination); return;
      }
      if (event.target.closest('[data-sc-back]')) { this.go(Math.max(0, this.step - 1)); return; }
      if (event.target.closest('[data-sc-next]')) {
        if (this.step === 0) this.choosePackage();
        else if (this.validateStep()) this.go(Math.min(4, this.step + 1));
        return;
      }
      if (this.step === 0 && event.target.closest('.sniffcar-packages__card,.sniffcar-packages__input')) {
        const label = event.target.closest('.sniffcar-packages__card');
        const input = label ? this.root.querySelector(`[id="${label.htmlFor}"]`) : event.target;
        // The browser's label default action and Dawn's native variant request run first.
        setTimeout(() => this.choosePackage(input?.value), 0);
      }
    }

    choosePackage(value) {
      if (this.step !== 0) return;
      this.pendingValue = value || this.picker.querySelector('input:checked')?.value;
      if (!this.pendingValue) return;
      this.notice('Das Paket wird geladen …');
      this.navigation.querySelector('[data-sc-next]').disabled = true;
      clearTimeout(this.packageTimeout);
      this.packageTimeout = setTimeout(() => {
        if (!this.pendingValue) return;
        this.pendingValue = null;
        this.navigation.querySelector('[data-sc-next]').disabled = false;
        this.notice('Das Paket konnte noch nicht geladen werden. Bitte noch einmal auswählen.');
      }, 15000);
      this.finishPackageSelection();
    }

    selectedVariant() {
      try { return JSON.parse(this.picker.querySelector('[data-selected-variant]').textContent); }
      catch { return null; }
    }

    finishPackageSelection() {
      const variant = this.selectedVariant();
      const formId = this.productForm.querySelector('input[name="id"]')?.value;
      if (!variant || variant.option1 !== this.pendingValue || String(variant.id) !== formId) return;
      if (!variant.available) {
        this.pendingValue = null; clearTimeout(this.packageTimeout);
        this.navigation.querySelector('[data-sc-next]').disabled = false;
        this.notice('Dieses Paket ist aktuell nicht verfügbar. Bitte ein anderes Paket wählen.'); return;
      }
      this.pendingValue = null; clearTimeout(this.packageTimeout);
      this.navigation.querySelector('[data-sc-next]').disabled = false;
      // Dawn restores focus after its section update. Advance once that update has completed.
      requestAnimationFrame(() => { if (this.step === 0) this.go(1); });
    }

    go(step) {
      this.step = step;
      this.visited = Math.max(this.visited, step);
      this.notice('');
      this.updateHeading();
      this.refresh();
      const title = this.header.querySelector('.sc-wizard__title');
      title.focus({ preventScroll: true });
      this.header.scrollIntoView({ behavior: 'instant', block: 'start' });
    }

    updateHeading() {
      this.info.dataset.scStep = this.step;
      this.header.querySelector('.sc-wizard__counter').textContent = `Schritt ${this.step + 1} von ${steps.length}`;
      this.header.querySelector('.sc-wizard__title').textContent = steps[this.step][1];
      this.header.querySelector('.sc-wizard__description').textContent = steps[this.step][2];
      this.progress.querySelectorAll('button').forEach((button, index) => {
        button.disabled = index > this.visited;
        if (index === this.step) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
        cls(button, 'is-complete', index < this.step);
      });
    }

    applyPanels() {
      // Do not touch Globo's disabled attributes or its conditional-display flags.
      concealed(this.picker, this.step !== 0);
      concealed(this.appBlock, this.step === 0);
      concealed(this.summary, this.step !== 4);
      concealed(this.price, this.step !== 4);
      concealed(this.tax, this.step !== 4);
      // Keep the original app payment/trust banners visible in every step.
      // CSS conceals only the native checkout controls until the review step.
      this.app.querySelectorAll('.gpo-total').forEach(total => concealed(total, this.step !== 4));
      this.navigation.querySelector('[data-sc-back]').hidden = this.step === 0;
      this.navigation.querySelector('[data-sc-next]').hidden = this.step === 4;
      this.navigation.querySelector('[data-sc-next]').textContent = nextLabels[this.step] || 'Weiter →';
      const packageButton = this.header.querySelector('.sc-wizard__package');
      packageButton.hidden = this.step === 0;
      const variant = this.selectedVariant();
      if (variant) {
        const parts = variant.title.split('|');
        const text = `${parts[0].trim()} · ${parts[1]?.trim() || ''} – Ändern`;
        if (packageButton.textContent !== text) packageButton.textContent = text;
      }
    }

    conditionVisible(field) {
      return !field.matches('[data-clo-display="show"]') &&
        !field.closest('.gpo-group[data-clo-display="show"]');
    }

    activeFields(step = this.step) {
      return Array.from(this.app.querySelectorAll(`[data-sc-field-step="${step}"]`))
        .filter(field => this.conditionVisible(field));
    }

    notice(message) {
      const notice = this.navigation.querySelector('.sc-wizard__notice');
      notice.textContent = message; notice.hidden = !message;
    }

    validateStep() {
      if (this.app.querySelector('.gpo-uploading,[data-gpo-image-editor-loading]')) {
        this.notice('Die Datei wird noch hochgeladen. Bitte einen Moment warten.'); return false;
      }
      const fields = this.activeFields();
      const quantity = this.app.querySelector('.gpo-quantity__input');
      if (this.step === 2 && quantity?.getClientRects().length && !quantity.disabled && !quantity.checkValidity()) {
        this.notice('Bitte eine ganze Anzahl ab 1 für den Intensivduft-Zuschlag eingeben.');
        quantity.focus(); return false;
      }
      for (const field of fields) {
        const controls = Array.from(field.querySelectorAll('input,select,textarea')).filter(x => !x.disabled);
        for (const input of controls) {
          // Never replay a file-change event: Globo could upload the same file again.
          if (input.type === 'file' || input.type === 'hidden' || (input.type === 'radio' && !input.checked)) continue;
          input.dispatchEvent(new Event(input.matches('select,[type="radio"],[type="checkbox"]') ? 'change' : 'input', { bubbles: true }));
        }
        const requiredFile = field.querySelector('input[type="file"][presence]:not(:disabled)');
        if (requiredFile && !field.querySelector('.gpo-f-card') && !field.querySelector('[data-has-file]')) {
          this.notice('Bitte die erforderliche Datei hochladen.'); requiredFile.focus(); return false;
        }
        const requiredRadio = field.querySelector('input[type="radio"][presence]:not(:disabled)');
        if (requiredRadio && !field.querySelector('input[type="radio"]:checked')) {
          this.notice('Bitte die erforderliche Auswahl vervollständigen.');
          field.querySelector('.dropdown-button')?.click(); return false;
        }
      }
      const invalid = fields.find(field => field.classList.contains('has-error') || field.querySelector('.help-block.error'));
      if (invalid) {
        this.notice('Bitte die markierte Angabe prüfen, bevor es weitergeht.');
        invalid.querySelector('input:not([type="hidden"]),textarea,select')?.focus(); return false;
      }
      return true;
    }

    revealError() {
      if (this.step !== 4) return;
      const invalid = Array.from(this.app.querySelectorAll('.gpo-element.has-error')).find(field => this.conditionVisible(field));
      if (invalid && Number(invalid.dataset.scFieldStep) >= 0) {
        this.go(Number(invalid.dataset.scFieldStep));
        this.notice('Bitte die markierte Angabe prüfen.');
      }
    }

    fieldValue(id) {
      const field = this.app.querySelector(`[data-element-id="${id}"]`);
      if (!field || !this.conditionVisible(field)) return '';
      const file = field.querySelector('input[type="file"]');
      if (file) {
        const names = Array.from(file.files || []).map(x => x.name);
        if (names.length) return names.join(', ');
        const cards = field.querySelectorAll('.gpo-f-card');
        return cards.length ? `${cards.length} Datei${cards.length === 1 ? '' : 'en'} hochgeladen` : 'Keine Datei hochgeladen';
      }
      const control = field.querySelector('input[type="radio"]:checked') ||
        field.querySelector('select,textarea,input[type="tel"],input[type="phone"],input[type="text"]:not(.dropdown-suggestion)');
      return control?.value?.trim() || '';
    }

    renderSummary() {
      const rows = [];
      const variant = this.selectedVariant();
      if (variant) rows.push(['Gewähltes Paket', variant.title.split('|').slice(0, 2).map(x => x.trim()).join(' · '), 0]);
      rows.push(['Vorderseite', this.fieldValue('file-1'), 1], ['Rückseite', this.fieldValue('file-2'), 1]);
      rows.push(['Form', this.fieldValue('image-dropdown-1') || 'Keine Form gewählt', 1]);
      if (this.fieldValue('textarea-2')) rows.push(['Wunschform', this.fieldValue('textarea-2'), 1]);
      const scents = this.activeFields(2).filter(field => /^image-dropdown-/.test(field.dataset.elementId));
      scents.forEach((field, index) => rows.push([scents.length > 1 ? `Duft ${index + 1}` : 'Duft', this.fieldValue(field.dataset.elementId) || 'Noch nicht gewählt', 2]));
      rows.push(['Duftintensität', this.fieldValue('select-1') || 'Noch nicht gewählt', 2]);
      const addonQuantity = this.app.querySelector('#select-1_quantity');
      if (addonQuantity && !addonQuantity.disabled && this.fieldValue('select-1').includes('Intensivduft')) rows.push(['Anzahl Intensivduft-Zuschläge', addonQuantity.value, 2]);
      rows.push(['Designwünsche', this.fieldValue('textarea-1') || 'Keine zusätzlichen Hinweise', 3]);
      rows.push(['Telefonnummer', this.fieldValue('phone-1') || 'Nicht angegeben', 3]);
      const signature = JSON.stringify(rows);
      if (signature === this.summarySignature) return;
      this.summarySignature = signature;
      this.summary.replaceChildren();
      rows.forEach(([label, value, step]) => {
        const row = document.createElement('div'); row.className = 'sc-wizard__summary-row';
        const text = document.createElement('div');
        const term = document.createElement('strong'); term.textContent = label;
        const detail = document.createElement('p'); detail.textContent = value;
        const edit = document.createElement('button'); edit.type = 'button'; edit.dataset.scGo = step;
        edit.textContent = 'Ändern'; edit.setAttribute('aria-label', `${label} ändern`);
        text.append(term, detail); row.append(text, edit); this.summary.append(row);
      });
    }
  }

  const mount = () => document.querySelectorAll('[data-sniffcar-wizard]').forEach(root => {
    if (!root.sniffcarWizard) root.sniffcarWizard = new SniffcarWizard(root);
  });
  mount();
  document.addEventListener('DOMContentLoaded', mount);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('product-info:loaded', mount);
})();
